import set from 'lodash/set';
import { v4 as uuidv4 } from 'uuid';
import { Appearance } from '@atlaskit/section-message';
import { NotificationTypes } from '../components/notifications';
import { NotificationFlagType } from '../../notification-flag';
import { ReactNode } from 'react';

type NotificationType = Appearance;

type Options = {
  detailList?: (() => JSX.Element)[];
  id: string;
  dismissAfter?: number;
  withType: NotificationType | NotificationFlagType;
  isCloseable: boolean;
  version?: NotificationTypes;
};

export type NotificationInfoOptions = Options & {
  header: string;
  message: string;
};

type NotificationFlagOptions = Options & {
  header: ReactNode;
  message: ReactNode;
};

export type NotificationOptions = NotificationInfoOptions | NotificationFlagOptions;

const setValueOn = (obj: NotificationOptions, path: string, value: unknown) => {
  return set({ ...obj }, path, value);
};

const notificationBuilder = (
  // @ts-expect-error creating an object from the start:: TODO update notification builder
  options: NotificationOptions | undefined = {}
) => ({
  withHeader: (header: NotificationOptions['header']) => {
    return notificationBuilder(setValueOn(options, 'header', header));
  },
  withId: (id: NotificationOptions['id']) => {
    return notificationBuilder(setValueOn(options, 'id', id));
  },
  withDismissAfter: (dismissAfter?: NotificationOptions['dismissAfter']) => {
    return notificationBuilder(setValueOn(options, 'dismissAfter', dismissAfter));
  },
  withType: (type: NotificationOptions['withType']) => {
    return notificationBuilder(setValueOn(options, 'type', type));
  },
  withMessage: (message: NotificationOptions['message']) => {
    return notificationBuilder(setValueOn(options, 'message', message));
  },
  withDetailList: (detailList: NotificationOptions['detailList']) => {
    return notificationBuilder(setValueOn(options, 'detailList', detailList));
  },
  isCloseable: (isCloseable: NotificationOptions['isCloseable']) => {
    return notificationBuilder(setValueOn(options, 'isCloseable', isCloseable));
  },
  isVersion: (version: NotificationOptions['version']) => {
    return notificationBuilder(setValueOn(options, 'version', version));
  },
  build: () => {
    return options;
  },
});

const simpleNotificationBuilder = () => {
  return notificationBuilder().withId(uuidv4()).isCloseable(true);
};

export const errorNotificationBuilder = () => {
  return simpleNotificationBuilder().withType('error');
};

export const successNotificationBuilder = () => {
  return simpleNotificationBuilder().withType('success');
};

/**
 * @deprecated This has been deprecated. will be removed in a future release.
 * Use successNotificationBuilder instead with version flag to show success notifications.
 */
export const successNotificationFlagBuilder = () => {
  return simpleNotificationBuilder().withType('success');
};

export const warningNotificationBuilder = () => {
  return simpleNotificationBuilder().withType('warning');
};

export const infoNotificationBuilder = () => {
  return simpleNotificationBuilder().withType('information');
};

export default notificationBuilder();
